import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useGetUserData } from "@krea/customer-features/store/user/hooks/queries/useGetUserData";
import { isEmpty } from "lodash";

const PublicRoute = ({
  redirectOnPermissionDenied = "/",
  children,
}: {
  redirectOnPermissionDenied: string;
  children: ReactNode;
}) => {
  const { data: user } = useGetUserData();

  // If the user is empty (logged out), login and registration pages should be accessible
  if (isEmpty(user)) {
    return children;
  } else {
    return <Navigate replace={true} to={redirectOnPermissionDenied} />;
  }
};

export default PublicRoute;
